<template>
  <div v-if="!busy">
    <b-card
      v-for="lead in leads.slice(0, displayRows)"
      :key="lead[0].id"
      no-body
      :class="['shadow', 'border', 'my-3', 'cursor-pointer', {'priority-lead': !olderThanNow(lead.priority_access)}]"
      @click="goToLead(lead)"
    >
      <b-card-header class="d-flex align-items-center">
        <b-badge
          v-if="!olderThanNow(lead.priority_access)"
          class="priority-lead-badge d-flex align-items-center rounded position-absolute"
        >
          {{ lead[0].priority_access }}
          <span class="float-left" v-html="$t('Priority Access')" />
          <spinner :small="true" />
        </b-badge>
        <span
          v-else-if="lead.inCoverage === 1"
          :class="['status-icon', 'mx-1', 'text-success', 'position-absolute', 'lead__coverage']"
          title="Within Coverage Area"
        >
          <font-awesome-icon :icon="'circle'" />
        </span>
        <span
          v-else
          :class="['status-icon', 'mx-1', 'text-info', 'position-absolute', 'lead__coverage']"
          title="Outside Coverage Area"
        >
          <font-awesome-icon :icon="'circle'" />
        </span>
        <div :class="[{'priority-lead-title': !olderThanNow(lead.priority_access)}, 'col', 'col-12', 'd-inline-block', 'px-0', 'text-center']">
          <h2 class="h3 m-auto">
            {{ lead.work_type_translation }}
          </h2>
          <h3 class="m-auto">
            {{ leadShortAddress(lead.location, lead[0].postcode, lead.location_url) }}
          </h3>
        </div>
      </b-card-header>
      <b-card-body class="py-3 px-4 fadein-details">
        <div class="row">
          <div class="col lead__details">
            <dl class="row">
              <dt class="col-5">
                {{ $t('Date:') }}
              </dt>
              <dd class="col-7">
                {{ lead[0].request_date | parseDate }} {{ lead[0].request_date | parseTime }}
              </dd>
              <dt class="col-5">
                {{ $t('Timescale:') }}
              </dt>
              <dd class="col-7">
                {{ getTimescaleTranslation(lead[0].question_answers) }}
              </dd>
              <dt class="col-5">
                {{ $t('Leads Sold:') }}
              </dt>
              <dd class="col-7">
                {{ lead[0].sold }}/{{ lead[0].number_leads_requested }} {{ leadsSold(lead[0].sold, lead[0].number_leads_requested) }}
              </dd>
            </dl>
          </div>

          <div class="col-3 lead__buy d-flex">
            <div class="align-self-top">
              <span class="d-block mb-2">{{ $t('Price:') }}<strong>{{ $n(lead.dashboardPrice, 'currency') }}</strong></span>
              <router-link
                class="btn-sm btn btn-outline-primary"
                :to="{name:'buy-leads', query:{enquirycode: lead[0].quote_code}}"
              >
                {{ $t('View') }}
              </router-link>
            </div>
          </div>
        </div>
        <template>
          <div class="row">
            <div class="col-12">
              <strong>{{ $t('Qualification notes:') }}</strong> {{ lead[0].description }}
            </div>
          </div>
        </template>
      </b-card-body>
    </b-card>
  </div>
  <spinner v-else :class="'my-0 py-3 bg-white'" />
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import LeadsSoldMixin from "@/imports/mixins/leadsSold";
import LeadShortAddressMixin from "@/imports/mixins/leadShortAddress";
import OlderThanNow from "@/imports/mixins/olderThanNow";
import workTypeTranslation from "@/imports/mixins/workTypeTranslation";
import company from "@/imports/mixins/company";
import { captureError } from "@/services/userMonitoring";

export default {
  name: "MarketplaceLeadsListLite",
  components: {Spinner},
  mixins: [LeadsSoldMixin, LeadShortAddressMixin, OlderThanNow, workTypeTranslation, company],
  props: ["displayRows"],
  data() {
    return {
      busy: false,
      page: 1,
      leads: [],
      refresh: false,
    }
  },
  methods: {
    getLeads: async function () {
      try {
        this.busy = true;
        let result = await this.$api.leads.marketplace();
        this.leads = result.data.data;
      } catch (e) {
        captureError(e, {
          section: "marketplace",
          action: "get-leads",
          type: "api-request"
        });
      }
    },
    goToLead: function(lead) {
      this.$router.push({name:'buy-leads', query: {enquirycode: lead[0].quote_code}});
    }
  },
  created: function () {
    this.getLeads().then(() => {
      this.busy = false;
    });
  }
}
</script>

<style scoped lang="scss">
.card {
  &-header {
    position: relative;

    h3 {
      font-size: $font-size-13;
    }
  }

  &-body {
    @include font-size($font-size-14);
  }
}

.priority-lead {
  .card-body {
    border-radius: $border-radius $border-radius 0 0;
    .card-header:first-child {
      border-radius: $border-radius $border-radius 0 0;
    }
  }
  &-badge {
    font-size: 10px;
    position: absolute;
    padding: 5px;
    background: linear-gradient(to right, $notification-icon-color, $priority-light-color);
    box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    color: $theme-primary;
    line-height: 1.3;
    text-align: left;
    left: -10px;
    max-width: 75px;

    ::v-deep .ripple--small {
      width: 25px;
      height: 25px;
    }
  }
  &-title {
    max-width: calc(100% - 95px);
    margin: 0 auto;
  }
}

@media only screen and (max-width: 330px) {
  .lead__details,
  .lead__buy {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .lead__buy {
    text-align: center;
    margin-bottom: $h3-font-size;
    justify-content: center;
  }
}

</style>
